module.exports = __webpack_public_path__ + "static/img/dialog_4.5416de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/aprilfoolsday/dialog/dialog_4.png
// module id = H8Fl
// module chunks = 1